<template>
    <z-basePage :title="'添加职员'" :pop="true">
        <infoTpl></infoTpl>
    </z-basePage>
</template>

<script>
    import infoTpl from 'src/components/person-detail/tab/person-info.vue'

    export default {
        components:{
            infoTpl,
        },
        beforeRouteLeave(to,from,next){  //离开页面之前
			let res = this.$form.leave({name:'back-add-person',path:to.path});
			next(res);
        },
        
    }
</script>

<style lang="less">
</style>





// WEBPACK FOOTER //
// page-add-people.vue?45562ad8